import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_cameraPlus",
  "use": "icon_cameraPlus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon_cameraPlus\"><path d=\"M12 16a3 3 0 100-6 3 3 0 000 6z\" stroke=\"#005F89\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M12 4h-2a1 1 0 00-1 1 2 2 0 01-2 2H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2v-7M15 6h6M18 3v6\" stroke=\"#005F89\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol